var map = {
	"./all.svg": 3304,
	"./art.svg": 84997,
	"./beauty-spas.svg": 76396,
	"./entertainment.svg": 12357,
	"./evacuation-center.svg": 53038,
	"./health-care.svg": 17423,
	"./medical.svg": 51402,
	"./polling-place.svg": 32934,
	"./public-places.svg": 13708,
	"./restaurant.svg": 51189,
	"./shop.svg": 3642,
	"./toilet.svg": 73225,
	"./tourist-attraction.svg": 21009,
	"./transportation.svg": 51425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46990;